module.exports = __webpack_public_path__ + "static/media/notification-blue.1b7c3597.svg";